import { useCallback } from 'react'
import { QueryState, stringifyRequestQuery } from '../../../../../../_metronic/helpers'
import { getAvaliacoes } from '../../../avaliacoes/avaliacoes-list/core/_requests'
import { getPrescricoes } from '../../prescricao/core/_requests'

const buildQuery = (
  pacienteId: string | undefined,
  page: number,
  size: number,
  extra?: Partial<QueryState>
) => {
  const state: QueryState = {
    page,
    size,
    search: pacienteId ? `atendimento.paciente.id:${pacienteId}` : '',
    sort: 'data',
    order: 'desc',
    ...extra,
  }

  return stringifyRequestQuery(state)
}

/**
 * Os fetchers são memoizados por `pacienteId` porque entram no array de dependências do
 * `useEffect` de `HistoricoSection`: sem isso, cada render do pai disparava uma nova busca.
 */
export const useHistoricoPaciente = (pacienteId?: string) => {
  const fetchAvaliacoes = useCallback(
    async (page: number, size: number) => {
      const query = buildQuery(pacienteId, page, size, {
        filters: [{ field: 'concluidos', operator: '=', value: true }],
      })

      return getAvaliacoes(query)
    },
    [pacienteId]
  )

  const fetchPrescricoes = useCallback(
    async (page: number, size: number) => {
      const query = buildQuery(pacienteId, page, size)

      return getPrescricoes(query)
    },
    [pacienteId]
  )

  return {
    fetchAvaliacoes,
    fetchPrescricoes,
  }
}
